import { useEffect, useState } from "react"
import { defaultPrimarySalesList, DistinctToken } from "../PoolContext"
import { bindActionCreators } from "redux";
import { useDispatch } from "react-redux";
import { actionCreators } from "../state";
import { TabTitle } from "../components/typography/Typogtaphy";
import CardsCollectionPrimaryMarket, { CardsCollectionInvestSecondaryMarket } from "../components/utils/CardsCollection";
import { BackButton, DexxButton } from "../components/light/LightButton";
import { isLogged } from "../functions/session";
import LoadingContainer from "../components/utils/LoadingContainer";

export default function AssetRoute(): JSX.Element {

    const dispatch = useDispatch()
    const actions = bindActionCreators(actionCreators, dispatch)
    const [tokens, setTokens] = useState<any[]>([])
    const [primarySalesList, setPrimarySalesList] = useState(defaultPrimarySalesList)
    const [shownList, setShownList] = useState<any[]>([])
    const [activeTab, setActiveTab] = useState<boolean[]>([true, false, false, false, false])
    const [hideCards, setHideCards] = useState<number[]>([])
    const [category, setCategory] = useState<string>("All")
    const [categoryID, setCategoryID] = useState<number>(0)
    const [distinctTokenList, setDistinctTokenList] = useState<any[]>([])
    let url = window.location.href
    let p = url.slice(url.lastIndexOf('#') + 1)
    const [tabLP, setTabLP] = useState<boolean>(p === "secondary")
    const logged = isLogged()


    const REFRESH_PERIOD = 20000; //20 SEC

    useEffect(() => {
        actions.getAllSecondaryMarket(setTokens)
        actions.getAllPrimarySales(setPrimarySalesList)
    }, [])

    useEffect(() => {
        const interval = setInterval(() => {
            actions.getAllSecondaryMarket(setTokens)
            actions.getAllPrimarySales(setPrimarySalesList)
        }, REFRESH_PERIOD);
        return () => clearInterval(interval)
    }, [])

    useEffect(() => {
        if (primarySalesList) {
            setShownList(primarySalesList.primary_sales.filter(function (t) {
                if (logged || (!logged && t.asset_category !== "IF")) {
                    if (t.status !== "Ended") return t
                    else {
                        var today = new Date()
                        if (t.pct_sold < 100) {  // not sold out -> keep for 30d
                            var days30 = new Date(t.date_end)
                            days30.setDate(days30.getDate() + 30)
                            return today < days30

                        } else {                // sold out -> keep for 180d
                            var days180 = new Date(t.date_end)
                            days180.setDate(days180.getDate() + 180)
                            return today < days180
                        }
                    }
                }
            }))
        }
    }, [primarySalesList])

    useEffect(() => {
        var all: any = []
        var tmp: DistinctToken = {
            token_uuid: "",
            token_ticker: "",
            token_category: "",
            token_name: ""
        }

        if (tokens) {
            for (var i = 0; i < tokens.length; i++) {
                if (logged || (!logged && tokens[i].asset_class !== "IF")) {
                    tmp = {
                        token_uuid: tokens[i].uuid,
                        token_ticker: tokens[i].ticker,
                        token_category: tokens[i].asset_class,
                        token_name: tokens[i].asset_name
                    }
                    all.push(tmp)
                }
            }
        }
        if (all)
            setDistinctTokenList(all)

    }, [tokens])

    function changeView(category: string, id: number) {
        setCategory(category)
        setCategoryID(id)
        const tmp = category === "All"
            ? []
            : (!tabLP ? shownList : distinctTokenList)
                .map((item, index) => item[!tabLP ? 'asset_category' : 'token_category'] !== category ? index : -1)
                .filter(index => index !== -1);
        setHideCards(tmp)
        var tmp2 = activeTab
        tmp2 = tmp2.map((_, i) => { return (i === id ? true : false) })
        setActiveTab(tmp2)
    }

    function Tab(props: { category: string, id: number, color?: string }): JSX.Element {
        const cat = props.category === "INVESTMENT FUNDS" ? "IF" : props.category
        const color = tabLP ? "succ3" : "succ2"
        return <>
            <div onClick={() => { changeView(cat, props.id) }}
                className={"cursor-pointer mx-1 md:text-3xl " +
                    (activeTab[props.id] ? "text-" + color : "")}>
                {props.category}</div>
        </>
    }

    useEffect(() => {
        changeView(category, categoryID)
        if (!tabLP)
            window.history.replaceState("", "", "/invest")
        else
            window.history.replaceState("", "", "/invest#secondary")
    }, [tabLP])

    return (
        <>
            <LoadingContainer isReady={true}>
                <div className="h-full px-2">
                    <div className="w-full px-10 pb-2">
                        <div className="flex gap-5 place-content-center mx-neg80 mt-2">
                            <DexxButton label={"primary market"}
                                onClick={() => setTabLP(false)}
                                className={"rounded-lg px-6 py-3 " +
                                    (tabLP ? "" : "bg-succ2_lightest")}
                                fontClasses=" font-normal md:text-sm text-xs"
                                color2={tabLP ? "white" : "succ2"}
                                color1={"white"} color3="white_lighter"
                                noHoverOnSelected={!tabLP} />
                            <DexxButton label={"secondary market"}
                                onClick={() => setTabLP(true)}
                                className={"rounded-lg px-6 font-normal py-3 " +
                                    (tabLP ? "bg-succ3_lightest" : "")}
                                fontClasses="font-normal md:text-sm text-xs 
                                drop-shadow-xl shadow-black"
                                color2={tabLP ? "succ3" : "white"}
                                color1={"white"} color3="white_lighter"
                                noHoverOnSelected={tabLP} />
                        </div>
                        <TabTitle className="flex place-content-center mt-8 gap-2 z-10 flex-wrap
                            mx-neg80 md:mb-6 mb-neg40">
                            <Tab category="All" id={0} />
                            <Tab category="ART" id={1} />
                            <Tab category="SPORTEX" id={2} />
                            {logged ? (<Tab category="INVESTMENT FUNDS" id={3} />) : <></>}
                            <Tab category="COLLECTABLES" id={4} />
                        </TabTitle>

                        <div className="md:text-18xl text-9xl uppercase flex place-content-center
                            z-0 font-roboto font-normal text-darkblue whitespace-nowrap
                            mx-neg80 leading-48 overflow-clip mt-5 overflow-hidden
                            mb-neg80">
                            {tabLP ? "Secondary market" : "Primary sale"}
                        </div>

                        {(!tabLP && shownList) ? <CardsCollectionPrimaryMarket tokensList={shownList} hide={hideCards}
                            categoryName={category} /> : <></>}
                        {(tabLP && distinctTokenList) ? <CardsCollectionInvestSecondaryMarket uniqueTokens={distinctTokenList}
                            hide={hideCards} categoryName={category} isLogged={logged} /> : <></>}
                    </div>
                    <div className="flex justify-center mt-5">
                        <BackButton />
                    </div>
                </div>
            </LoadingContainer>
        </>
    )
}